<template>
  <!-- Navbar -->
  <div class="container px-0">
    <ItemSideNav />
  </div>
  <div class="pb-md-5 mb-5">
    <div class="container">        
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb mb-3">
          <li class="breadcrumb-item text-dark opacity-5">
            <a
              href="javascript:;"
              @click="goToPage('/')"
            >昀揚科技</a>
          </li>
          <li class="breadcrumb-item text-dark opacity-5">
            <a 
              href="javascript:;"
              @click="goToPage('News')"
            >最新消息</a>
          </li>
          <li
            class="breadcrumb-item text-dark active"
            aria-current="page"
          >
            <template v-if="nid==12">
              昀揚科技於2024智慧城市展成功展示「TronMap Metaverse」全方位智慧園區管理解決方案
            </template>
            <template v-if="nid==11">
              昀揚科技攜「TronMap Metaverse」於2024智慧城市展Smart City Summit & Expo展出
            </template>
            <template v-if="nid==10">
              新北市政府教育局-校舍管理系統，榮獲2023雲端物聯網創新獎之優良應用獎
            </template>
            <template v-if="nid==9">
              雲端題庫評量命題系統翻轉未來智慧教育 讓學校更Smart!!
            </template>
            <template v-if="nid==8">
              一眼掌握雲端園區 監控管理好幫手：創益圖Tron Map
            </template>
            <template v-if="nid==7">
              雲端教材智慧整合 TronEdu創益學 為業界提供最佳選擇
            </template>
            <template v-if="nid==6">
              昀揚科技受邀參加2023臺灣數位信任科技應用交流會
            </template>
            <template v-if="nid==5">
              雲端題庫評量命題系統翻轉未來智慧教育 讓學校更Smart!!
            </template>
            <template v-if="nid==4">
              CRStream Standard影音串流媒體服務開發與整合的最佳解決方案
            </template>
            <template v-if="nid==3">
              新北市教育局-教育成果
            </template>
            <template v-if="nid==2">
              讓TronEdu EMS Essentials Plus解決您的命題煩惱
            </template>
            <template v-else-if="nid==1">
              新北市教育局導入VMware Tanzu Greenplum大數據平台，推動智慧教育發展
            </template>
          </li>
        </ol>
      </nav>
      <div class="card p-3 pt-md-4 px-md-5 pb-md-6">
        <h3 class="mb-4">
          <template v-if="nid==12">
            昀揚科技於2024智慧城市展成功展示「TronMap Metaverse」全方位智慧園區管理解決方案
          </template>
          <template v-if="nid==11">
            昀揚科技攜「TronMap Metaverse」於2024智慧城市展Smart City Summit & Expo展出
          </template>
          <template v-if="nid==10">
            新北市政府教育局-校舍管理系統，榮獲2023雲端物聯網創新獎之優良應用獎
          </template>
          <template v-if="nid==9">
            新聞：2023教育科技展EdTech Taiwan開展，昀揚科技「TronEdu 創益學」您最佳的教育科技解決方案！
          </template>
          <template v-if="nid==8">
            一眼掌握雲端園區 監控管理好幫手：創益圖Tron Map
          </template>
          <template v-if="nid==7">
            雲端教材智慧整合 TronEdu創益學 為業界提供最佳選擇
          </template>
          <template v-if="nid==6">
            昀揚科技受邀參加 2023臺灣數位信任科技應用交流會
          </template>
          <template v-if="nid==5">
            雲端題庫評量命題系統翻轉未來智慧教育 讓學校更Smart!!
          </template>
          <template v-if="nid==4">
            CRStream Standard影音串流媒體服務開發與整合的最佳解決方案
          </template>
          <template v-if="nid==3">
            新北市教育局-教育成果
          </template>
          <template v-if="nid==2">
            讓TronEdu EMS Essentials Plus解決您的命題煩惱
          </template>
          <template v-else-if="nid==1">
            新北市教育局導入VMware Tanzu Greenplum大數據平台，推動智慧教育發展
          </template>
        </h3>
        <div class="author">
          <template v-if="nid==12">
            <p class="my-auto">
              2024年3月27日
            </p>
            <span class="badge bg-gradient-success ms-2">創益圖 Tron Map</span>
          </template>
          <template v-if="nid==11">
            <p class="my-auto">
              2024年03月04日
            </p>
            <span class="badge bg-gradient-success ms-2">創益圖 Tron Map</span>
          </template>
          <template v-if="nid==10">
            <p class="my-auto">
              2023年11月23日
            </p>
            <span class="badge bg-gradient-success ms-2">創益圖 Tron Map</span>
          </template>
          <template v-if="nid==9">
            <p class="my-auto">
              2023年11月15日
            </p>
            <span class="badge bg-gradient-primary ms-2 text-capitalize">TronEdu 創意學</span>
          </template>
          <template v-if="nid==8">
            <p class="my-auto">
              2023年10月31日
            </p>
            <span class="badge bg-gradient-success ms-2">創益圖 Tron Map</span>
          </template>
          <template v-if="nid==7">
            <p class="my-auto">
              2023年10月31日
            </p>
            <span class="badge bg-gradient-primary ms-2 text-capitalize">TronEdu 創意學</span>
          </template>
          <template v-if="nid==6">
            <p class="my-auto">
              2023年10月27日
            </p>
            <span class="badge bg-gradient-warning ms-2 text-capitalize">TronSecurity</span>
          </template>
          <template v-if="nid==5">
            <p class="my-auto">
              2023年6月20日
            </p>
            <span class="badge bg-gradient-primary ms-2 text-capitalize">TronEdu 創意學</span>
          </template>
          <template v-if="nid==4">
            <p class="my-auto">
              2023年6月20日
            </p>
            <span class="badge bg-gradient-info ms-2 text-capitalize">CRStream 影音串流</span>
          </template>
          <template v-if="nid==3">
            <p class="my-auto">
              2023年6月20日
            </p>
            <span class="badge bg-gradient-primary ms-2 text-capitalize">TronEdu 創意學</span>
          </template>
          <template v-if="nid==2">
            <p class="my-auto">
              2023年3月29日
            </p>
            <span class="badge bg-gradient-primary ms-2 text-capitalize">TronEdu 創意學</span>
          </template>
          <template v-if="nid==1">
            <p class="my-auto">
              2023年3月28日
            </p>
            <span class="badge bg-gradient-primary ms-2 text-capitalize">TronEdu 創意學</span>
          </template>
        </div>
        <hr class="border my-3">

        <template v-if="nid==12">
          <div>
            <p class="blockquote border border-success rounded p-3 text-success mb-4 font18">
              昀揚科技股份有限公司在「2024智慧城市展暨2050淨零城市展」中展示「TronMap Metaverse」全方位智慧園區管理解決方案獲得熱烈關注
            </p>
            <div 
              class="position-relative"
              @click="drawPrivateModalPage"
            >
              <a class="nicole-member-center text-warning shadow-lg"><i
                class="fa-solid fa-circle-play  bg-white rounded-circle"
                style="font-size: 4rem;cursor: pointer;"
              /></a>
              <img
                src="@/assets/img/newmap9.jpg"
                class="w-100 img-fluid rounded"
              >
            </div>
            <div class="row">
              <!--
                <div class="col-12 rounded overflow-hidden"> 
                    <video class="w-100 z-index-0 rounded-5 px-0" id="video" playsinline="playsinline"
                        autoplay="autoplay" muted="muted" loop="loop" poster="assets/img/back2.jpg" style="object-fit: cover;">
                        <source type="video/mp4" src="assets/img/mapnews1.mp4">
                    </video>
                </div>
              -->
              <div class="col-12 mt-4">    
                <p class="text-dark mb-4 lh-lg font18">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
		在近期舉行的「2024智慧城市展暨2050淨零城市展」中，昀揚科技股份有限公司（以下簡稱昀揚科技）憑藉其領先的智慧城市解決方案「TronMap Metaverse」系列參展，
		吸引了大量看展人員和業界專家的目光。
                </p>
                <p class="text-dark mb-4 lh-lg font18">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
			在展覽現場，昀揚科技專門展示了「園區建築管理平台 BMMS」的楖念性應用。
			該系統是一款先進的用於雲端園區建築繪圖與管理的平台，擁有自家研發的「園區建築繪圖動畫引擎」。
			這個平台結合了「園區建築物管理系統」和「園區建築繪圖系統」等多項專利技術，
			使用 ParkDraw 在圖台上進行建築物件的繪製和管理，包括樓層、室內空間、公共空間、設備圖示、設施圖標、警示、通知、導覽內容和動態訊息等屬性內容。
			此外，繪圖過程中所有繪圖物件的衛星座標會同步儲存在雲端資料庫，座標精準度達到小數點14位。
			BMMS提供每一個繪圖物件的API使其能夠將渲染整合至 Google Map ( PMN )、元宇宙 ( ParkMeta )、AR (ParkAR)或其他GIS圖台，
			提供精確、動態及更多元生動的智慧園區管理應用體驗。
                </p>   
              </div>
              <div class="col-xl-4">
                <img
                  class="image-right border-radius-lg img-fluid shadow-lg mb-3"
                  src="@/assets/img/newmap2.jpg"
                >
                <img
                  class="image-right border-radius-lg img-fluid shadow-lg mb-3"
                  src="@/assets/img/newmap4.jpg"
                >
              </div>                
              <div class="col-xl-4">
                <img
                  class="image-right border-radius-lg img-fluid shadow-lg mb-3"
                  src="@/assets/img/newmap5.jpg"
                >
                <img
                  class="image-right border-radius-lg img-fluid shadow-lg mb-3"
                  src="@/assets/img/newmap6.jpg"
                >
              </div>                 
              <div class="col-xl-4">
                <img
                  class="image-right border-radius-lg img-fluid shadow-lg mb-3"
                  src="@/assets/img/newmap7.jpg"
                >
                <img
                  class="image-right border-radius-lg img-fluid shadow-lg mb-3"
                  src="@/assets/img/newmap8.jpg"
                >
              </div>                 
                
 
                               
              <div />
              <p class="text-dark mb-4 lh-lg font18">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
		除此之外，昀揚科技的「園區建築管理系統 BMMS」
		AIOT 設備挷定模組，可在繪圖物件屬性上進行AIOT設備的挷定，繼承了連結與顯示的物件方法
		可在智慧聯網（AIoT）、物聯網（IoT）、ESG、EMS 等先進科技整合，
		應用在消防、安防、戰情室、指揮中心、資安等情境，
		為縣市政府和企業各單位提供一站式、全方位的智慧式園區應用解決方案。
              </p>                
              <p class="text-dark mb-4 lh-lg font18">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
		昀揚科技的「TronMap Metaverse」系列在本次展覽中的成功展示，
		進一步凸顯了公司在園區管理領域的技術優勢和創新能力，
		也強化了其在市場上的領先地位和品牌形象。
		參加「2024智慧城市展」不僅是一次重要的展示機會，
		也是對昀揚科技不斷追求技術創新和市場拓展策略的肯定。
		未來，昀揚科技將持續致力於研發更多創新產品和解決方案，
		為建設智慧城市和實現淨零碳排放的未來做出更大的貢獻。
              </p> 
            </div>
            <div class="row mt-3"> 
              <div class="col-xl-4 mb-3">
                <img
                  class="image-right border-radius-lg w-100 h-100 shadow-lg mb-3"
                  src="@/assets/img/newmap1.jpg"
                  style="object-fit: cover;"
                >
              </div>                     
              <div class="col-xl-4 mb-3">
                <img
                  class="image-right border-radius-lg w-100 h-100 shadow-lg mb-3"
                  src="@/assets/img/newmap10.jpg"
                  style="object-fit: cover;"
                >
              </div>                    
              <div class="col-xl-4 mb-3">
                <img
                  class="image-right border-radius-lg w-100 h-100 shadow-lg mb-3"
                  src="@/assets/img/newmap11.jpg"
                  style="object-fit: cover;"
                >
              </div>                        
            </div>
          </div>
        </template>
        <template v-if="nid==11">
          <div>
            <p class="blockquote border border-success rounded p-3 text-success mb-4 font18">
              昀揚科技於2023年10月25日推出「TronMap Metaverse」，將於113年03月19日(四)至03月22日(五)在【2024智慧城市展Smart City Summit & Expo】台北南港展覽館2館 Q202 盛大展出。
            </p>
            <div class="row align-items-end">
              <div class="col-xl-12">
                <p class="text-dark mb-2 lh-lg font18">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  「TronMap Metaverse」 系列的主平台 BMMS v2.0 是一套用於雲端園區建築繪圖與園區建築管理的系統，
                  使用昀揚科技自製研發的「園區建築繪圖動畫引擎」，結合「園區建築物管理系統」與「園區建築繪圖系統」等多項專利技術，
                  可在地球圖台上上繪製建築物件並且管理樓層、室內空間、公共空間、設備圖示、設施圖標、警示、通知、導覽內容、動態訊息等屬性內容，
                  繪圖的過程會將所有繪圖物件的衛星座標同步儲存在雲端資料庫（座標精準度達小數點 14 位），主要可以應用在
                  智慧園區、地圖導覽、元宇宙、物流通路、AIOT 設備資訊、ESG、EMS、資產管理、資安 SOC 監控管理、違規取締等服務
                </p>
              </div>               
              <div class="col-md-5">
                <img
                  class="image-right border-radius-lg img-fluid shadow-lg mb-3"
                  src="assets/img/city1.jpg"
                >
              </div> 
              <div class="col-md-7">
                <img
                  class="image-right border-radius-lg img-fluid shadow-lg mb-3"
                  src="assets/img/city3.jpg"
                >
                <img
                  class="image-right border-radius-lg img-fluid shadow-lg mb-3"
                  src="assets/img/bmms2.jpg"
                >
              </div>
            </div>                 
 
            <div class="row mt-3">
              <div class="col-xl-12">
                <p class="text-dark mb-4 lh-lg font18">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;TronMap Metaverse 系列有五大系統，主平台為園區建築管理平台（BMMS v2.0），園區繪圖系統（ParkDraw）、園區元宇宙平台（ParkMeta）、園區地圖導覽平台（PMN）、創益 Security 平台（TronSecurity），使用者可彈性選擇軟體授權或訂閱制方案。
                </p>                 
              </div>                 

              <div>              
                <div class="p-3 info-horizontal">
                  <div class="d-flex align-items-center mb-2"> 
                    <div> 
                      <div class="icon icon-shape  bg-gradient-success text-center rounded-pill shadow-none">
                        <i class="fas fa-layer-group opacity-10 text-lg" />
                      </div>
                    </div>
                    <div class="ms-3"> 
                      <h5 class="mb-0 ">
                        園區建築管理平台
                      </h5>
                      <span class="text-normal  text-info">BMMS Platform</span>
                    </div>
                  </div>
                  <div class="description ps-5">
                    <ul class="mb-0">
                      <li class="mb-3">
                        分別有園區管理模組、衛星地圖模組、建築設施管理模組、物件管理模組、動態訊息模組、快速鍵模組及「園區建築繪圖動畫引擎」開發的建築設施物件模組、物件圖層模組、園區畫布模組、建築設施繪圖模組、建築空間繪圖模組、園區導覽模組、渲染列印匯出模組。
                      </li>
                    </ul>
                  </div>
                </div> 
                <div class="p-3 info-horizontal">
                  <div class="d-flex align-items-center mb-2"> 
                    <div>
                      <div class="icon icon-shape  bg-gradient-success text-center rounded-pill shadow-none">
                        <i class="fas fa-map-location-dot opacity-10 text-lg" />
                      </div>
                    </div>
                    <div class="ms-3">
                      <h5 class="mb-0">
                        園區地圖導覽平台
                      </h5>                
                      <span class="text-normal  text-info">Park Map Navigation Platform , PMN</span>
                    </div>
                  </div>
                  <div class="description ps-5">
                    <ul class="mb-0">
                      <li class="mb-3">
                        在地圖座標位置上，顯示建築物、公共空間、室內空間、設備、設施等物件及智能園區相關資訊。
                      </li>
                    </ul>
                  </div>
                </div> 
                <div class="p-3 info-horizontal">
                  <div class="d-flex align-items-center mb-2"> 
                    <div>
                      <div class="icon icon-shape  bg-gradient-success text-center rounded-pill shadow-none">
                        <i class="fas fa-pen-swirl opacity-10 text-lg" />
                      </div>
                    </div>
                    <div class="ms-3">
                      <h5 class="mb-0">
                        園區繪圖平台
                      </h5>                
                      <span class="text-normal  text-info">Park Drawing , ParkDraw</span>
                    </div>  
                  </div>
                  <div class="description ps-5">
                    <ul class="mb-0">
                      <li class="mb-3">
                        可安裝並支援 Microsoft Windows 與 MacOS 等作業系統的繪圖管理工具。
                      </li>
                      <li class="mb-3">
                        可在3D沉浸式實景地球圖台上繪製及管理建築、樓層、室內空間、公共空間、設備圖示、設施圖標等繪圖物件。
                      </li>
                      <li class="mb-3">
                        可將所有物件發佈到 PMN 平台 或 ParkMeta 平台做各種應用及導覽。
                      </li>
                    </ul>
                  </div>
                </div>              
                <div class="p-3 info-horizontal">
                  <div class="d-flex align-items-center mb-2"> 
                    <div>
                      <div class="icon icon-shape  bg-gradient-success text-center rounded-pill shadow-none">
                        <i class="fas fa-planet-ringed opacity-10 text-lg" />
                      </div>
                    </div>
                    <div class="ms-3">
                      <h5 class="mb-0">
                        園區元宇宙平台
                      </h5>                
                      <span class="text-normal  text-info">Park Metaverse Platform , ParkMeta</span>
                    </div>  
                  </div>
                  <div class="description ps-5">
                    <ul class="mb-0">
                      <li class="mb-3">
                        透過ParkDraw渲染物件到ParkMeta的地球圖台座標位置上，可導覽及顯示建築物、公共空間、室內空間、設備、設施等物件及智能園區等相關繪圖物件資訊。
                      </li>
                      <li class="mb-3">
                        沉浸式實景（Immersive View） 鳥瞰圖模組。
                      </li>
                      <li class="mb-3">
                        支援 Microsoft Windows 與 MacOS、IOS、Android 等環境。
                      </li>
                    </ul>
                  </div>
                </div> 
                <div class="p-3 info-horizontal">
                  <div class="d-flex align-items-center mb-2"> 
                    <div>
                      <div class="icon icon-shape  bg-gradient-success text-center rounded-pill shadow-none">
                        <i class="fas fa-shield-halved opacity-10 text-lg" />
                      </div>
                    </div>
                    <div class="ms-3">
                      <h5 class="mb-0">
                        創益 Security 平台
                      </h5>                
                      <span class="text-normal  text-info">TronSecurity Platform</span>
                    </div>  
                  </div>
                  <div class="description ps-5">
                    <ul class="mb-0">
                      <li class="mb-3">
                        與工研院技術合作推出 FIDO2、MFA 等模組快速部署零信任架構 ( ZTA )
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-if="nid==10">
          <div class="row">
            <div class="col-xl-8">
              <p class="text-dark mb-4 lh-lg font18">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;恭賀新北市政府教育局榮獲「2023雲端物聯網創新獎之優良應用獎」，我司與新北市政府教育局合作開發之校舍管理系統為本次參與競賽之亮點平台之一！校舍管理系統為昀揚科技的「創益圖 TronMap」系列產品-「園區建築管理平台系統 ( BMMS Platform Node ) 」授權給新北市政府教育局，於新北市300所學校進行校園平面圖的繪圖、建築物相關資訊連結應用及管理。
              </p> 
              <p class="text-dark mb-4 lh-lg font18">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;創益圖 TronMap 包含 「園區建築管理平台系統 ( BMMS Platform Node ) 」，它是一套用於雲端園區建築繪圖與園區建築管理的系統，在園區繪圖的過程中系統會將所有設施、建築等繪圖物件的衛星座標即時儲存在雲端資料庫（座標精準度達小數點 14 位），在建築物繪圖物件上可使用動畫模組繪製樓層、室內空間、公共空間等分佈資訊與屬性，並可在建築物繪圖物件上管理樓層、室內空間、公共空間、設備圖示、設施圖標、警示、通知、導覽內容、動態訊息等屬性內容，主要可以應用在智慧園區、園區地圖導覽、元宇宙、AIOT設備資訊、EGS、資產管理、資安 SOC 監控管理等服務。
              </p>  
            </div>               
            <div class="col-12 col-xl-4">
              <div class="row">
                <div class="col-12 col-md-6 col-xl-12">
                  <img
                    class="image-right border-radius-lg img-fluid shadow-lg mb-3"
                    src="assets/img/reward1.jpg"
                  > 
                </div> 
                <div class="col-12 col-md-6 col-xl-12">    
                  <img
                    class="image-right border-radius-lg img-fluid shadow-lg"
                    src="assets/img/reward3.jpg"
                  >
                </div>                
              </div>                
            </div>                
          </div>
        </template>
        <template v-if="nid==9">
          <div>
            <div class="row">                    
              <div>
                <img
                  class="image-right img-fluid position-relative mt-lg-4 rounded h-100"
                  src="assets/img/editech3.jpg"
                  alt="image"
                >
              </div>
              <div class="mt-3 mt-lg-4">
                <p class="text-dark mb-4 lh-lg font18">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;昀揚科技股份有限公司於教育科技產業深耕多年，持續研發教育科技解決方案，今年攜「TronEdu 創益學」、「TronMap 創益圖」、「TronSecurity 創益Security」 三大系列產品，於112年11月9日(四)至11月12日(日)在臺北資訊月【臺灣教育科技展】世貿一館盛大展出。
                </p>                  
              </div>
              <div class="col-lg-6 order-1 order-lg-2" />    
            </div>  
            <div class="pt-3 col-12">
              <p class="text-dark mb-4 lh-lg font18">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;本次昀揚科技受新北市教育局邀請，協助新北市教育局向參觀的教職人員及民眾展示並說明「雲端題庫評量命題系統」與「校園平面繪圖系統」的開發理念、系統功能介紹、未來應用願景。
              </p>

              <p class="text-dark lh-lg font18">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                在今年活動主軸「科技教育 玩出學習力」中，昀揚科技展出「TronEdu 創益學」系列中的「創益題 Exam Editor」及「影音串流平台 CRStream」，提供教育界人士更方便且熟悉的編輯器，將命題流程線上化，讓課程教授雲端化，結合「創意學 Curriculum Platform」，提供符合108課綱，支援全科、全版、小學到高中的知識架構平台，將數位科技應用於教學，透過便利快速的科技應用及豐富有趣的數位內容，讓學習者能善用科技輔助學習。藉由本次參加展出與現場參與臺灣教育科技展的教育界人士、廣大師生與家長進行交流及經驗分享，從教師、家長及學生三個面向推廣昀揚科技將教育與科技結合之創新應用成果。
              </p>
            </div> 
            <div class="d-none d-md-block">
              <div class="row min-vh-25">
                <div class="col-md-8 col-lg-7 mb-md-0 mb-3">
                  <div
                    style="background-image: url(assets/img/editech1.jpg)"
                    class="w-100 h-100 border-radius-lg shadow bg-cover"
                  />
                </div>
                <div class="col-md-4 col-lg-5 mb-md-0 mb-3">
                  <div
                    style="background-image: url(assets/img/editech4.jpg)"
                    class="w-100 h-100 border-radius-lg bg-cover"
                  />
                </div>
              </div>
            </div>
            <div class="d-none d-md-block">    
              <div class="row min-vh-25 mt-4">
                <div class="col-md-6 col-lg-4 mb-md-0 mb-3">
                  <div
                    style="background-image: url(assets/img/editech2.jpg)"
                    class="w-100 h-100 border-radius-lg shadow bg-cover"
                  />
                </div>
                <div class="col-md-6 col-lg-5 mb-md-0 mb-3">
                  <div
                    style="background-image: url(assets/img/editech6.jpg)"
                    class="w-100 h-100 border-radius-lg shadow bg-cover"
                  />
                </div>
                <div class="d-none d-lg-block col-lg-3 mb-md-0 mb-3">
                  <div
                    style="background-image: url(assets/img/editech5.jpg)"
                    class="w-100 h-100 border-radius-lg shadow bg-cover"
                  />
                </div>
              </div> 
            </div> 
            <div class="d-md-none row">
              <div class="col-12 mb-md-0 mb-3  min-vh-35">
                <div
                  style="background-image: url(assets/img/editech1.jpg)"
                  class="w-100 h-100 border-radius-lg shadow bg-cover"
                />
              </div>
              <div class="col-12 mb-md-0 mb-3  min-vh-35">
                <div
                  style="background-image: url(assets/img/editech4.jpg)"
                  class="w-100 h-100 border-radius-lg bg-cover"
                />
              </div>

              <div class="col-12 mb-md-0 mb-3  min-vh-35">
                <div
                  style="background-image: url(assets/img/editech6.jpg)"
                  class="w-100 h-100 border-radius-lg shadow bg-cover"
                />
              </div>
              <div class="col-12 mb-md-0 mb-3  min-vh-35">
                <div
                  style="background-image: url(assets/img/editech2.jpg)"
                  class="w-100 h-100 border-radius-lg shadow bg-cover"
                />
              </div>
            </div>
          </div>
        </template>
        <template v-if="nid==8">
          <div>
            <p class="blockquote border border-success rounded p-3 text-success mb-4 font18">
              昀揚科技股份有限公司將於 2024 年 Q1 推出創益圖 Tron Map，
              近年來掌握「使用者應用生態圈」、透過以人為本的使用者行為與需求，結合智慧科技來創造最高價值的產業紛紛興起，
              在這一波智慧科技驅動資通訊產業的革命潮流中，
              為「園區管理」開啟了雲端化的新視野。
            </p>
            <div class="row">
              <div class="col-xl-6">
                <p class="text-dark mb-4 lh-lg font18">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;創益圖Tron Map的主要平台為BMMS(Building Map Management System)，園區建築管理平台系統，其使用昀揚科技股份有限公司自製研發的「園區建築繪圖動畫引擎」，擁有「園區建築物管理系統」與「園區建築繪圖系統」獨家專利技術，可在物件上進行樓層、室內空間、公共空間、設備圖示、設施圖標等分佈資訊的繪圖與屬性管理，繪圖的過程會將所有繪圖物件的衛星座標同步儲存在雲端資料庫（座標精準度達小數點 14 位）。BMMS結合園區地圖導覽平台（PMN）與智慧園區平台（IPP）兩大系統，將智慧園區打造如一個戰情中心，只要連結智慧園區平台並切換衛星地圖模式，即可使用上帝視角管理操作、體驗更多智能園區相關資訊和結果。
                </p> 
              </div>               
              <div class="col-xl-6">
                <img
                  class="image-right border-radius-lg img-fluid shadow-lg mb-3"
                  src="assets/img/bmms2.jpg"
                >
              </div>              
            </div>                 
 
            <div class="row mt-3">                  
              <div class="col-xl-6">
                <img
                  class="image-right border-radius-lg img-fluid shadow-lg mb-3"
                  src="assets/img/bmms3.jpg"
                >
              </div>
              <div class="col-xl-6">
                <p class="text-dark mb-4 lh-lg font18">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;為了讓使用者建立一個安全方便不會被釣魚且易於管理的環境，昀揚科技股份有限公司與工研院技術合作推出 FIDO2、MFA 等模組快速部署零信任架構（ZTA ），此外，BMMS採用容器化微服務架構與RESTful API 風格架構開發，有著高度的可靠性（Reliability）、可用性（Availability）、可維護性（Serviceability），大幅度的節省部署與維運成本。
                </p>                 
                <p class="text-dark mb-4 lh-lg font18">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;BMMS可將繪圖物件發佈到 Google Maps Platform 及使用 API 客製化，未來可廣泛應用在智慧園區、園區地圖導覽、元宇宙、AIOT設備資訊、EGS、資產管理、資安 SOC 監控管理等服務，多元面向提升更優質且更即時的管理方式。
                </p> 
              </div> 
            </div>
          </div>          
          &#160;
        </template>

        <template v-if="nid==7">
          <div>
            <div class="row">
              <div class="mt-4 col-lg-5 order-2 order-lg-1">
                <p class="text-dark mb-4 lh-lg font18">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  昀揚科技股份有限公司將於 2024 年 Q1 推出 TronEdu 創益學平台（Curriculum Platform），我們積累數年教育科技整合的豐富經驗，
                  並整合與各家教育集團、教育機構、地方政府、學校編輯人員、各領域教師的編輯操作使用經驗，
                  推出支援小學、國中、高中五個學習階段、108課綱、全領域及領域架構、全科、全版本及知識架構的課程管理系統。
                </p>                  
              </div>                   
              <div class="col-lg-7 order-1 order-lg-2">
                <img
                  class="image-right border-radius-lg img-fluid position-relative bg-cover shadow-lg mt-lg-4"
                  src="assets/img/edu5.jpg"
                  alt="image"
                  loading="lazy"
                >
              </div>  
            </div>  
            <div class="row mt-4 justify-content-center">                      
              <div class="col-10 col-xl-4 col-lg-6 ">
                <img
                  class="image-right border-radius-lg img-fluid position-relative bg-cover shadow-lg mt-lg-4"
                  src="assets/img/edu4.jpg"
                  alt="image"
                  loading="lazy"
                >
              </div>                            
              <div class="pt-3 col-lg-6 col-xl-8">
                <p class="text-dark mb-4 lh-lg font18">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  TronEdu 創益學平台（Curriculum Platform）擁有「智能雲端課程編排系統」、「智能出卷系統」、「智能排課系統」等人工智能應用相關獨家專利技術，使用者可透過昀揚科技的雲端資料中心更新教育部公佈每年最新版的知識架構與課綱，亦可應用在專業證照、教育訓練、高普考、幼兒等需求，客製化知識架構及課綱。數位管理有效為使用者解決不同課程版本無法統一教材內容而造成巨額維護成本與時間的難題。
                </p>

                <p class="text-dark mb-4 lh-lg font18">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  除了創益學平台（Curriculum Platform）此一主要平台，
                  昀揚科技另外還有提供可再加購的創益題平台（Exam Platform）、
                  CRStream 多媒體串流平台（CRStream Platform）、
                  雲端技術支援平台（Cloud Raise Support Platform）、
                  創益 Security 平台（TronSecurity Platform），
                  並分別將於 2024 年推出遠距教學平台（Distance Learning Platform），
                  2025 年推出智能應用平台（AI Platform）、智能訓練平台（AI Training Platform），
                  均可各別選擇採購軟體授權或訂閱制方案，部署在線上考試、出卷、線上影音函授課程、電子書、學力診斷、學習診斷、智能補救、智能助理、遠距教學等雲端應用。
                </p>
              </div>

              <p class="text-dark mb-3 lh-lg font18 mt-xl-5">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;創益題平台（Exam Platform）的「跨載具命題系統」與CRStream 多媒體串流平台（CRStream Platform）的Streaming Media Distribution Network ( SMDN ) 皆為昀揚科技獨家的專利技術，具備豐富且複雜又多元的人員編輯、平台應用、全載具應用技術know-how，是一套成熟穩定的產品。此外，創益學平台（Curriculum Platform）與工研院技術合作推出 MFA 與 FIDO2 等相關模組，輕鬆一鍵搞定安裝導入零信任架構（ZTA）。
              </p>                            
              <p class="text-dark mb-4 lh-lg font18 mt-xl-5">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;TronEdu 創益學平台（Curriculum Platform）採用容器化微服務架構與RESTful API 風格架構開發，不僅支援多種行動應用載具 ( iOS、Android、Smart TV、WEB、點讀筆等) ，亦可將服務快速的佈建在 iPhone、iPad、Android Phone、Android Pad、Smart TV、PC、WEB等載具上，將TronEdu 創益學平台（Curriculum Platform）整合到使用者當前的教學應用平台或 SaaS platform，是業界最理想的優質選擇。
              </p>  
              <div class="d-flex justify-content-center">
                <div class="col-lg-10">
                  <img
                    class="image-right border-radius-lg img-fluid position-relative bg-cover  mt-lg-4"
                    src="assets/img/tronedu2.jpg"
                    alt="image"
                    loading="lazy"
                  >
                </div>
              </div>
            </div>
          </div>

          &#160;
        </template>

        <template v-if="nid==6">
          <div>
            <div class="row">
              <div class="mb-5">
                <img
                  class="image-right border-radius-lg img-fluid position-relative bg-cover shadow-lg mb-3"
                  src="assets/img/securitynews-xl.jpg"
                  alt="image"
                  loading="lazy"
                >
                <span>
                  圖／昀揚科技應工業技術研究院邀請參與數位發展部數位產業署於10月27日舉辦「2023臺灣數位信任科技應用交流會」。
                </span>
              </div>


              <div class="mb-4 mt-4 col-lg-7 order-2 order-lg-1">
                <p class="text-dark mb-4 lh-lg font18">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  昀揚科技股份有限公司將於 2024 年 Q1 推出「創益Security（TronSecurity）」資訊安全的解決方案，
                  與工研院資安整合服務平台（Security Platform as a Services , SECPAAS）以及歐生全 AuthenTrend 三方進行技術轉移合作，
                  提供使用者建立零信任架構（ZTA）中決策引擎「身分鑑別」的核心機制。
                </p>                  
                <p class="text-dark mb-4 lh-lg font18">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  現場提供的『 TronEdu 』與『 TronMap 』 昀揚科技兩套產品系統進行 ZTA 身份鑑別功能展示及說明。
                  使用者可使用 FIDO2 於網站服務平台下進行 無密碼 或 多因子認證（MFA）方式登入，並提供資訊人員一個安全方便易於管理維護的系統平台。
                </p>                  
                <p class="text-dark mb-4 lh-lg font18">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  TronSecurity 全面採用容器化微服務架構，大型企業或公部門組織可使用 Kubernetes ( K8s ) 快速部署組織內部專屬的服務信任方（Relying Party，RP）平台，也可彈性選擇訂閱制方案。
                  組織內部相關部門只要自行註冊網站服務信任方（Relying Party，RP），即可獲取信任方提供的整合工具平台 ( RP Tools Platform Node) 及代碼等整合工具，
                  快速將 FIDO2 及 MFA 服務整合到您的網站平台上。
                </p>                  

                <p class="text-dark mb-4 lh-lg font18 mt-4">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  數位發展部唐鳳部長說明，現代民眾日常生活中越發依賴各類數位服務，
                  例如：線上購物、 社群交友、訊息分享以及個人資料管理等，
                  因此，迫切需要一個安全且可信任的數位環境，例如提供快速而安全的身份識別機制，
                  以確保網路身份不被盜用；有效的個人隱私保護措施，確保個人資訊不會被未經授權的單位或個人濫用以確保數位環境能夠從源頭預防不誠實行為，
                  使民眾可以放心的參與各種數位活動，而不必擔心安全性和隱私問題。
                </p>
                <p class="lh-lg font16">
                  詳細新聞內容來自&nbsp;<a
                    class="link-info"
                    target="_blank"
                    href="https://moda.gov.tw/ADI/news/latest-news/8631"
                  >數位發展部建立數位信任環境、推動信任科技協助防詐</a>
                </p>
              </div>                   
              <div class="col-lg-5 order-1 order-lg-2">
                <img
                  class="image-right border-radius-lg img-fluid position-relative bg-cover shadow-lg"
                  src="assets/img/ZTA_2023.png"
                  alt="image"
                  loading="lazy"
                >
              </div>                
            </div>  
          </div>          
          &#160;
        </template>

        <template v-if="nid==5">
          <div>
            <div class="row">                    
              <div>
                <img
                  class="image-right img-fluid position-relative bg-cover mt-lg-4"
                  src="assets/img/syudy1.jpg"
                  alt="image"
                  loading="lazy"
                >
              </div>
              <div class="mt-3 mt-lg-4">
                <p class="text-dark mb-4 lh-lg font18">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;在面對「各學制多系統、教師數位能力養成、科技化學習環境需求、重視學生學習主體性」的挑戰下，以「未來智慧學校」揚升教與學之便利性及學校行政效能，引領各校邁向智慧校園。2022年10月，昀揚科技股份有限公司為「數位轉型」開啟一個里程碑，開發推出了雲端題庫評量命題系統，建置智慧化命題系統、規格化民間教育集團與政府教育機構命題流程，題庫編輯人員可建立定期評量試題，並標註學制、年級、科目、學習重點等，匯聚而成各學習領域題庫，最後依單位需求產出紙本、數位施測等多元試卷；學員受評後可將紀錄留存於系統中，成為「個人化數位學習履歷」，編輯人員進而清楚瞭解其學習需求，提供學習扶助，達成因材施教的目標。2023年8月新北市教育局已將雲端題庫評量命題系統導入全市國中使用，後續依照國中推動狀況將繼續逐步推廣至國小高年級及高中階段。
                </p>                  
              </div>
              <div class="col-lg-6 order-1 order-lg-2" />    
            </div>  
            <div class="row align-items-center mb-5 justify-content-center">                      
              <div class="col-9 col-xl-4 col-lg-6 ">
                <img
                  class="image-right img-fluid position-relative bg-cover mt-lg-4"
                  src="assets/img/ccc.png"
                  alt="image"
                  loading="lazy"
                >
              </div>                            
              <div class="pt-3 col-lg-6 col-xl-8">
                <p class="text-dark mb-4 lh-lg font18">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;雲端題庫評量命題系統使用獨家「智能雲端課程編排系統」專利技術，可以有效率地解決各校不同課程版本造成課程內容無法統一的問題，結合CRStream 多媒體串流平台（CRStream Platform）的Streaming Media Distribution Network（SMDN）與創益題平台（Exam Platform）的「跨載具命題系統」兩大獨家專利技術，大幅度的降低現行小學、國中、高中的全科、全版編輯及全載具解析度…等管理數位教材內容及剪輯維護影片的應用整合風險。
                </p>

                <p class="text-dark lh-lg font18 d-md-none">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  雲端題庫評量命題系統採用容器化微服務架構與RESTful API 風格架構開發，有著高度的可靠性（Reliability）、可用性（Availability）、可維護性（Serviceability），此外，與工研院技術合作推出 FIDO2、MFA 等模組快速部署零信任架構（ZTA ），有利於使用者建立一個安全方便不會被釣魚且易於管理的環境。
                </p>
              </div>
            </div>
            <p class="text-dark mb-4 lh-lg font18 d-none d-md-block">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              雲端題庫評量命題系統採用容器化微服務架構與RESTful API 風格架構開發，有著高度的可靠性（Reliability）、可用性（Availability）、可維護性（Serviceability），此外，與工研院技術合作推出 FIDO2、MFA 等模組快速部署零信任架構（ZTA ），有利於使用者建立一個安全方便不會被釣魚且易於管理的環境。
            </p> 
            <p class="text-dark mb-4 lh-lg font18 mt-xl-5">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;昀揚科技股份有限公司的開發腳步與時俱進，2024年將強力推出遠距教學平台 ( Distance Learning Platform )，讓教育工作者與學員可使用攝影機透過整合的 Zoom API 進行遠距教學應用。2025年將以採集的Token讓大語言模型（LLM）訓練出更人性化且聰明的「人工智能助教」、「人工智能家教」模型，提供學力診斷、學習診斷、適性診斷、智能命題、智能出卷、智能排課、智能助教、智能家教等功能，提供教育單位與相關業者後台與API服務，落實更完善的智慧教育。
            </p>
          </div>

          &#160;
        </template>

        <template v-if="nid==4">
          <div>
            <p class="blockquote border border-info rounded p-3 text-info mb-4 font18">
              還在為高額的網路影音串流媒體服務煩惱嗎?還在擔心創作的影音內容被偽造盜用嗎?CRStream Standard提供您低成本又安全的影音串流媒體服務。
            </p>
            <div class="row">
              <div class="col-lg-6 pt-3 order-2 order-lg-1">
                <p class="text-dark mb-4 lh-lg font18">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;昀揚科技於今年6月推出的CRStream Standard是一套針對影音串流媒體服務開發與整合所設計的最佳解決方案，其中包含CRStream Convert影音轉檔工具和CRStream API影音管理系統以及提供全載具（手機、平板、電腦、智能電視）播放SDK，使用者可以運用本系統快速建置及擴展高效穩定的影音串流媒體服務。
                </p>
                <p class="mb-5 text-dark mb-4 lh-lg font18">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  本產品擁有多項專利以及SMDN（Streaming Media Distribution Network）獨家專利技術，將串流媒體儲存在多個網路資料中心（IDC），針對使用者的載具資源、伺服器資源、TCP傳輸指派較近、較順暢的伺服器節點，將資料傳輸給使用者，自動優化串流媒體服務的播放品質，盡可能提高效能，使高頻寬的應用服務（高畫質影片）更加順暢。
                </p>
              </div>
              <div class="col-lg-6 order-1 order-lg-2">
                <div>
                  <img
                    class="image-right border-radius-lg img-fluid position-relative bg-cover shadow-lg"
                    src="assets/img/crstream1.jpg"
                    alt="image"
                    loading="lazy"
                  >
                </div>
              </div>    
            </div>  
            <div class="row mt-5">          
              <div class="col-12 col-md-9 col-lg-4 order-1 order-lg-1 mb-3 mx-md-auto mx-lg-0">
                <div class="blur-shadow-image">
                  <img
                    class="image-right border-radius-lg img-fluid position-relative bg-cover shadow-lg"
                    src="assets/img/crstream2.jpg"
                    alt="image"
                    loading="lazy"
                  >
                </div>
              </div>                    
              <div class="col-lg-7 pt-3 order-2 order-md-3 order-lg-2">
                <p class="text-dark mb-4 lh-lg font18">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;其中CRStream Convert影音轉檔工具支援MP3、MP4、AVI、RM、RMVB…等多種檔案格式，此外，上傳時也支援圖文浮水印、串流服務雙重認證與時效認證、AES128媒體檔案及TLS1.2以上SSL加密，再藉由影音媒體USB KEY串流加密解碼，不僅有效保護智財權，更重要的是能在網路發達、盜錄猖獗的時代，防止任何盜錄影音的可能性。
                </p>
                <p class="text-dark mb-4 lh-lg font18">
                  CRStream API影音管理系統支援圖文導讀及影音內容跟讀同步的功能，使用者可以針對不同影音自行設置導讀、跟讀的內容並預覽播放效果，CRStream API也免費提供SDK開發元件(播放元件、跟讀元件、導讀元件)，支援Web、Android、iOS全載具播放功能，配合系統中各項個人管理、功能給使用者，讓使用者可以打造一個專屬的個人化影音管理系統。
                </p>
              </div>
            </div>
          </div>
        </template>



        <template v-if="nid==3">
          <div class="row">                    
            <div class="mb-3">
              <img
                class="image-right border-radius-lg img-fluid position-relative bg-cover shadow-lg"
                src="assets/img/newsnt1.jpg"
              > 
            </div>                
            <span>
              圖／新北市政府教育局-教育成果-優質教育。
            </span>
            <p class="text-dark my-4 lh-lg font18">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;新北市教師善用數位學習工具，更關注學生的學習成效，因此建置命題評量模組，重視命題評量診斷，利用大數據的回饋審視校準學生每一步的學習，已學生為中心，為幸福而教。
            </p>                
            <p class="lh-lg font16">
              以上文章內容引用自&nbsp;<a
                class="link-info"
                target="_blank"
                href="https://www.ntpc.edu.tw/home.jsp?id=ea63572cd5291017&amp;act=be4f48068b2b0031&amp;dataserno=97f8518814f758fe8fe8d69d2c35ad54&amp;mserno=f5c12a43b8e10aa380850cc25011f4bc#"
              >智慧教師Ready Go ! 新北迎接智慧學習新時代</a>
            </p>
          </div>
        </template>

        <template v-if="nid==2">
          <div>
            <p class="blockquote border border-primary rounded p-3 text-primary mb-4 font18">
              老師們，是否還在為每次段考的命題任務感到困擾?是否還在擔心考題的方向不夠全面?這些煩惱讓Cloud Raise昀揚科技的TronEdu EMS Essentials Plus來幫你解決。
            </p>
            <div class="row">
              <div class="col-lg-6 pt-3 order-2 order-lg-1">
                <p class="text-dark mb-4 lh-lg font18">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;TronEdu EMS Essentials Plus是一套提供給老師和編輯人員處理命題、出卷、考試、分析、診斷等資訊應用服務需求的雲端產品，累積數年豐富的K12教育科技整合經驗，已廣泛使用於各大教育集團、地方政府及學校單位。
                </p>
                <p class="mb-5 text-dark mb-4 lh-lg font18">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  TronEdu EMS Essentials Plus採用標準化的RESTful API風格架構和容器化微服務架構，支援全載具(手機、平板、電腦、電視)等環境，使用者可以運用本系統快速的建置、擴展高效穩定的題庫應用服務，是最友善且符合命題老師和編輯人員使用習慣的雲端資料中心系統。
                </p>
              </div>
              <div class="col-lg-6 order-1 order-lg-2">
                <div class="blur-shadow-image">
                  <img
                    class="image-right border-radius-lg img-fluid position-relative bg-cover shadow-lg"
                    src="assets/img/news-2.jpg"
                    alt="image"
                    loading="lazy"
                  >
                </div>
              </div>    
            </div>  
            <div class="row">          
              <div class="col-md-6 col-lg-4 order-1 order-lg-1 mb-3">
                <div class="blur-shadow-image">
                  <img
                    class="image-right border-radius-lg img-fluid position-relative bg-cover shadow-lg"
                    src="assets/img/news-1.jpg"
                    alt="image"
                    loading="lazy"
                  >
                </div>
              </div>                    
              <div class="col-lg-7 pt-3 order-2 order-md-3 order-lg-2">
                <p class="text-dark mb-4 lh-lg font18">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;本產品是由(一) Cloud Raise TronEdu Exam Editor 2.0 - 題庫編輯軟體工具，以及(二) Cloud Raise TronEdu Exam API 2.0 - 題庫雲端服務系統所組成。
                </p>
                <p class="text-dark mb-4 lh-lg font18">
                  (一) Cloud Raise TronEdu Exam Editor 2.0 - 題庫編輯軟體工具 : Cloud Raise TronEdu Exam Editor 2.0提供使用者更具有時間成本效益的題庫管理解決方案；使用者可以使用熟悉的Microsoft Office Word編寫題目，並透過Cloud Raise TronEdu Exam Editor 2.0 上傳至雲端題庫系統，即可產出對應的API，輕鬆達成與雲端題庫系統串接功能，並且把珍貴的題目資源存放於雲端題庫中。
                </p>
                <p class="text-dark mb-4 lh-lg font18">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;本軟體不僅可以輕鬆快速地將題目上傳至雲端題庫系統，其中的編輯工具程式更可支援各項便捷的功能，讓使用者有更多樣的選擇、更輕鬆的上手。
                </p>
              </div>
              <div class="col-lg-8 mt-lg-6 order-4  order-md-4 order-lg-3">  
                <p class="text-dark mb-4 lh-lg font18">
                  (二) Cloud Raise TronEdu Exam API 2.0 - 題庫雲端服務系統 : Cloud Raise TronEdu Exam API 2.0提供給使用者能夠快速檢視上傳的題庫資源的便利性，並給予帳號權限設定、功能權限設定的管控模組提高安全性，另外，使用者可透過Postman Platfrom模擬HTTP Request操作API程式，確認題庫雲端資源的內容正確性。
                </p>
                <p class="text-dark mb-4 lh-lg font18">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Cloud Raise TronEdu Exam API 2.0中也提供各項個人化設定、功能給使用者，讓使用者可以打造一個專屬的個人化題庫雲端服務系統。
                </p>
              </div>
              <div class="col-md-6 col-lg-4 order-3 order-md-2 order-lg-4 mb-4 mb-md-0">
                <img
                  src="assets/img/news-3.jpg"
                  class="img-fluid shadow-lg border-radius-lg "
                >
              </div>
            </div>
          </div>
        </template>

        <template v-if="nid==1">
          <div>
            <p class="blockquote border border-primary rounded p-3 text-primary mb-4 font18">
              VMware長期致力協助各產業邁向數位轉型，今日宣布首度跨足數位教育領域，透過VMware Tanzu Greenplum四階段計畫，為新北市雲端智慧科技中心量身打造大數據分析平台，共同推進以新興科技加速智慧教育發展的目標。
            </p>
            <div class="row">
              <div class="col-lg-7 pt-3 order-2 order-lg-1">
                <p class="text-dark mb-4 lh-lg font18">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;新北市教育局發展智慧教育已行之有年，今年更宣佈啟用全國首座雲端智慧科技中心，並盼能透過大數據力量，極大化校務資料與學習評量等運用效益。在VMware的協助下，新北市教育局採用VMware Tanzu Greenplum作為打造大數據平台的資料分析與軟體管理核心解決方案，並預計自110年起至115年逐步推進四階段導入，驅動教與學的雙軸轉型：
                </p>
                <ul class="text-dark lh-lg font18 mb-5">
                  <li>第一階段：執行資料的收集、清洗與硬體建置，以VMware Tanzu Greenplum建構大數據倉儲與視覺化圖表分析。</li>
                  <li>第二階段：整合校務評鑑系統、學生輔導、健康管理等異質資料，以作為學生健康顧問等未來分析應用基礎。</li>
                  <li>第三階段：運用上述已收集之資料，囊括會考、學測等全國性測驗所需之學習歷程計畫，進一步作為學生補救學習建議或生涯適性輔導等決策參考基礎。</li>
                  <li>第四階段：統整學生的外部數位足跡，透過VMware Tanzu Greenplum既有的人工智慧與機器學習技術進行數據分析，以提升中輟生與高關懷學生等預警系統的預測精準度。</li>
                </ul>    
                <p>影像資訊：VMware</p>
                <p>新聞來源：yahoo!新聞</p>
              </div>
              <div class="col-lg-5 order-1 order-lg-2">
                <div class="">
                  <img
                    class="image-right border-radius-lg img-fluid shadow-lg mb-3"
                    src="assets/img/vmware.webp"
                    alt="image"
                    loading="lazy"
                  >
                  <span>圖／VMware攜手新北市教育局導入VMware Tanzu Greenplum大數據分析平台。(yahoo!新聞)</span>
                </div>
              </div>    
            </div>  
          </div>
        </template>
      </div>
    </div>
  </div>

  <!-- -------- START FOOTER 7 w/ DARK BACKGROUND AND 3 COLUMNS ------- -->
  <Footer class="footer py-3 py-md-5 bg-gradient-dark position-relative overflow-hidden">
    <img
      src="assets/img/shapes/waves-white.svg"
      alt="pattern-lines"
      class="position-absolute start-0 top-0 w-100 opacity-1"
      loading="lazy"
    >
    <div class="container position-relative">
      <div class="row">
        <div class="col-md-6 me-auto my-auto text-md-start text-center">
          <a
            href="javascript:;"
            @click="goToPage('/')"
          >
            <img
              src="assets/img/logo-ct-dark.png"
              class="mb-3 footer-logo"
              alt="main_logo"
            >
          </a>
          <h6 class="text-white font-weight-bold text-uppercase mb-2">
            Cloud Raise Technology
          </h6>
          <p class="text-white mb-0">
            Copyright © 2023 by Cloud Raise Technology.
          </p>
        </div>
        <div class="col-md-6 ms-auto text-md-end text-white d-none d-md-block">
          <p class="mb-1">
            新北市三重區重新路五段609巷<br class="d-md-none">14號5樓之3
          </p>
          <p class="mb-1">
            service@cloudraise.com
          </p>
          <p class="">
            02-29992891
          </p>
        </div>
      </div>
    </div>
  </Footer>
  <PrivateModalPage
    :privatePkyId="privatePkyId"
  />
</template>
<script>
/* eslint-disable import/no-absolute-path */
// eslint-disable-next-line import/no-unresolved
import { config, crstream } from '@/include/config';
import {
  h,
  ref,
  toRefs,
  reactive,
  watch,
  inject,
  onMounted,
  onBeforeUpdate,
  onUpdated
} from 'vue';
import { oltConsole, oAA , oAuth, oApiError , oFrame } from '@/lib/oltModule/initOltVue3';
//import Header from '@/components/Header.vue';
import { SideNav , ItemSideNav , Header , Footer } from '@/components/Frame';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { PrivateModalPage } from '@/components/Preview' ;

export default {
  name: 'App',
  components: {
    //SideNav,
    ItemSideNav,
    //Header,
    //NavBar,
    // Settings,
    //Footer,
    PrivateModalPage,
  },
  setup() {

    /**
     *  swal start
     */
    const swal = inject('$swal');
    /**
     *  swal end
     */

    const router = useRouter();
    const route = useRoute();
    const store = useStore();

    const nid = ref();

    //console.log('router.currentRoute.value : ', router.currentRoute.value.query);
    if(router.currentRoute.value.query.nid == null || router.currentRoute.value.query.nid == '' ){
      swal.fire({
        icon:'error',
        html:'路徑錯誤！！',
        buttonsStyling: true,
        confirmButtonClass: 'md-button md-success',
        //confirmButtonText:t('messages.confirm_button'),
      }).then( result => {
        if (result.value) {
          //console.log('result : ' , result);
          //emit('addCallBack');
          //router.go(-1);
          goToPage('/');
        }
      });
    }
    nid.value= router.currentRoute.value.query.nid ; 

    //console.log('nid' , nid.value);

    
    const privatePkyId = ref('0');
    const currentProtocol = window.location.protocol;
    const urlKey = ref(currentProtocol == 'http:' ? 'url' : 'urls');
    const demoVideo = ref();

    function drawPrivateModalPage(){
      privatePkyId.value = demoVideo.value[urlKey.value] ;
	  
      	// console.log("privatePkyId");
      	// console.log(privatePkyId.value );
	
      // eslint-disable-next-line no-undef
      $('#private').modal('show');
    }

    function guestLogin(){

      const apiParam = {
          restApiDriver: config.crStreamApiDriver ,// token key from veex store 
          // auth
          token: "",
          // Debug Mode 
          apiPostDebug: false, // API 新增 除錯模式
          apiName: "admin_guest_login",
          form: {
              id: crstream.id,
              secret: crstream.secret,
              domain: "",
          },
      };
      //console.log('apiParam : ', apiParam);
      let resObj = oAA.postRecordVue3(apiParam);
      resObj.then((res) => {
          //console.log('res : ', res);
          if (res["admin_guest_login"] && res["admin_guest_login"]['tokens'] && res["admin_guest_login"]['tokens']['token']) {
            getVideo(res["admin_guest_login"]['tokens']['token'], crstream.id, crstream.secret, "", "N");
          }
      }).catch((exception) => {
          console.log("exception : " + exception);
          // console.log(err.response.data);
      });
    }

    function getVideo(token, id, secret, account, isPrivate) {
        const apiParam = {
            restApiDriver: config.crStreamApiDriver ,// token key from veex store 
            // auth
            token: token, // token key from veex store 
            // Debug Mode 
            apiGetPageDebug: false, // API getPageRecord 除錯模式
            apiGetRtAllRecordDebug: false, // rtAllRecord Debug 
            apiGetRtPageRecordDebug: false, // API getRt 除錯模式        
            // API Filter 
            apiName: 'video_custom',
            pageNumber: 1, // int32 
            pageSize: 10, // int 32
            pageSort: 'seq', // string 
            pageSortBy: 'asc', // string 
            customFilter: false,
            pageSearch: {
                vid: 51,
            }, // json format 
            pageGroup: '', // string 
            pageGroupBy: '', // string 
            pageMode: true, // 是否打開換頁邏輯，若設定 fale 則預設只抓 1000 筆，參考 FunsController.php 。
            module: "", // module 
            fun: "video", // fun 
            act: 'view', // act  
            // rt 
            rtSet: {},
            queueSpeed: 1, // 異步 IO queue 的 順序執行間隔時間 1/1000 秒
        };
        oAA.queueGetAllVue3(apiParam)
            .then(
                res => {
                    if (res.pageRecord && res.pageRecord.data && res.pageRecord.data.length > 0) {
                        demoVideo.value = res.pageRecord.data[0];
                        //videoSrc.value = res.pageRecord.data[0][urlKey.value];
                        postVideoLinkHistory(token, {
                            vid: res.pageRecord.data[0]["vid"],
                            video_name: res.pageRecord.data[0]["name"],
                            id: id,
                            secret: secret,
                            account: account,
                            get_video_time: moment(Date.now()).format('YYYY-MM-DD HH:mm:ss'),
                            year: moment(Date.now()).format('YYYY'),
                            month: moment(Date.now()).format('MM'),
                            day: moment(Date.now()).format('DD'),
                            hour: moment(Date.now()).format('HH'),
                            min: moment(Date.now()).format('mm'),
                        });
                    }
                }
            )
            .catch((err) => {
                oApiError.chkError(err, swal, t);
                //console.log(err);
            });
    }

        function postVideoLinkHistory(token, form){
            //console.log("[postVideoLinkHistory] form: ", form);
            const apiParam = {
                restApiDriver: config.crStreamApiDriver ,// token key from veex store 
                // auth
                token: token,
                // Debug Mode 
                apiPostDebug: false, // API 新增 除錯模式
                apiName: "video_link_history",
                form: form,
                fun: "VideoLinkHistory", // fun 
                act: 'view', // act 
            };
            let resObj = oAA.postRecordVue3(apiParam);
            resObj.then((res) => {
                //console.log('res : ', res);
            }).catch((exception) => {
                //console.log("exception : " + exception);
                //console.log(exception.response.data);
            });
        }
    guestLogin();

    onMounted(async () => {
      chkLogin();
    });
    // Reload MDInput End

    onUpdated(async () => {
      // 修改 VUE 時 必需全部強制關閉 Modals 
      // eslint-disable-next-line no-undef
      //await oAdminFrame.closeAllModals() ;
    }) ;

    function goToPage(page){
      if(router.currentRoute.value.name == page) { return; }
      router.push(page);
      //router.push({ path:'/' , query:{page:1,blid:1}} );
    }

    function chkLogin(){
      let isLogin = oAuth.isLogin(store);

      if(!isLogin){
        //router.push({ path: '/AuthPage/SignIn' });
      }
    }

    return {
      hiddenHeader:false,
      // api setting
      setDebugMode: true,
      apiDebug: false,
      apiName: '',
      perPage: 3, //筆數
      pageMode: true,
      perPageOptions: [5, 10, 25, 50, 75, 100],
      // data
      userInfo:{coin:0 , point:0},
      token:null,
      nid,
      privatePkyId,
      // function
      goToPage,
      chkLogin,
      drawPrivateModalPage,
    };
  },
  created() {
  },
  mounted() {
    oFrame.initMD();
  },
  methods: {
  }
};
</script>
<style scoped>
.nicole-member-center :hover{
  transform: scale(1.2);
  transition: 0.5s;
}
</style>
